<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Archive Events - Setup Order</div>
                  <p>You can change events list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/events" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <table class="table table-light table-bordered table-hover">
<!--              <tr>-->
<!--              <th>Event Id</th>-->
<!--              <th>Event Date</th>-->
<!--              <th>Image</th>-->
<!--              <th>Title</th>-->
<!--              <th>Type</th>-->
<!--              <th>Attendees</th>-->
<!--              </tr>-->
              <draggable v-model="archiveEvents.data" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in archiveEvents.data" :key="index">
                  <!--<td>{{item.displayOrder}}</td>-->
<!--                  <td>{{item.eventId}}</td>-->
                  <td>{{item.start_date}}</td>
                  <td><img class="table-thumbnail" :title="item.title":src="item.img_url" /></td>
                  <td>{{item.title}}</td>
                  <td>{{item.type === '1' ? 'Live': 'Talk'}}</td>
                  <td>{{item.eventAttendeesCount}}</td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updateEventListing">
              Update Listings Order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const eventsColumns = ['Event Id', 'Event Date', 'Image', 'Title', 'Attendees'];
    export default {
        name: 'PersonOrder',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
          archiveEvents: {
        data: []
    }
    }
    },
    methods: {
      updateEventListing () {
          let data = this.archiveEvents.data;
          let eventIds = data.map((obj) => {
            return obj.eventId
          });
          this.$store.dispatch('UPDATE_ARCHIVE_ORDER', {dispOrderEvents: eventIds})
            .then((res) => {
              console.log("UPDATE_EXPERTS_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/events')
            })
            .catch(err => {
              console.log("UPDATE_EXPERTS_ORDERING API error : ", err);
            })
        },
      fetchArchiveEvents () {
        this.$store.dispatch('FETCH_ALL_ARCHIEVE_EVENTS')
          .then((res) => {
            console.log('res', res)
            this.archiveEvents.data = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
    },
    created() {
        this.fetchArchiveEvents();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Events/OrderArchiveEvents.vue